import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/admin",
    component: MasterLayout,
    children: [
      {
        path: "usuarios",
        name: "admin.usuarios",
        component: () => import("@/views/admin/usuarios/index.vue")
      },
      {
        path: "precios",
        name: "admin.precios",
        component: () => import("@/views/admin/precios/index.vue")
      },
      {
        path: "servicios",
        name: "admin.servicios",
        component: () => import("@/views/admin/servicios/index.vue")
      },
      {
        path: "razones",
        name: "admin.razones",
        component: () => import("@/views/admin/razones/index.vue")
      },
      {
        path: "centros",
        name: "admin.centros",
        component: () => import("@/views/admin/centros/index.vue")
      },
      {
        path: "asesores",
        name: "admin.asesores",
        component: () => import("@/views/admin/asesores/index.vue")
      },
    ]
  }
]